<div class="dialog-container">
  <div class="form-header">
    <div >{{item.name}}</div>
  </div>
  <div  class="content">
    <div class="articleContainer">
      <iframe width="100%" height="{{containerHeight}}" id="article" [src]="safeUrl" frameborder="0" allow="autoplay; fullscreen">
      </iframe>
    </div>
  </div> 
</div>